<template>
  <v-container fluid style="width: 100%" class="px-5">
    <div v-if="$route.name === names.REPLACEMENTS.LIST">
      <v-toolbar
          class="removeBtnPaddingRight rounded-t-lg"
          color="#DADADA"
          dense
          flat
      >
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly"
            icon
            class="mr-0 dark-primary"
            @click="newReplacements"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
          <v-btn
              text
              @click="newReplacements"
              class="rounded-tr-lg dark-primary"
          >
            Назначить заместителя
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :server-items-length="count"
          :options.sync="options"
          :footer-props="{'items-per-page-options':[10,50,100]}"
          class="elevation-1 rounded-b-lg"
      >
        <template v-slot:item.user="{ item }">
          <span v-if="item.user_has_ban">
             <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="red lighten-2"
                      v-bind="attrs"
                      v-on="on"
                  >no_accounts</v-icon>
                </template>
            <span>Учетная запись пользователя заблокирована</span>
            </v-tooltip>
            <span class="ml-1" style="text-decoration: line-through;">{{ item.user }}</span>
          </span>
          <span v-else>{{ item.user }}</span>
        </template>
        <template v-slot:item.start_date="{ item }">
          <span v-if="item.start_date">{{ displayDate(item.start_date) }}</span>
          <span v-else>---</span>
        </template>
        <template v-slot:item.end_date="{ item }">
          <span v-if="item.end_date">{{ displayDate(item.end_date) }}</span>
          <span v-else>---</span>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-icon v-if="item.is_active" color="green">
            check_circle
          </v-icon>
          <v-icon v-else>
            radio_button_unchecked
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom v-if="item.start_date !== null">
            <template v-slot:activator="{ on, attrs }" v-if="item.start_date !== null">
              <v-icon
                  class="mr-2"
                  @click="editReplacements(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  @click="deleteReplacements(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="loadData()"
          >
            Обновить
          </v-btn>
        </template>
      </v-data-table>
      <EditDialog
          v-if="dialog_add_edit"
          :opened="dialog_add_edit"
          :edit="edit_status"
          :replacement-data="replacements_data"
          @close="closeEditDialog"
      ></EditDialog>
      <ApplyDialog
          v-if="dialog_delete"
          :opened="dialog_delete"
          :get-text="() => `Вы уверены, что хотите удалить заместителя ?`"
          @close="closeDeleteDialog"
      ></ApplyDialog>
    </div>
    <router-view v-else></router-view>
  </v-container>
</template>

<script>
import names from "../routers/names";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {mapActions, mapGetters} from "vuex";
import representative from "@/urls/roles/representative";
import names_core from "@/modules/core/routers/names";
import EditDialog from "@/modules/representative/replacements/modals/ReplacementsEditDialog.vue";
import ApplyDialog from "@/modules/core/components/ApplyDialog.vue";
import {displayDate} from "@/helper";
export default {
  name: "ReplacementList",
  components: {EditDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список заместителей",
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      replacements_data: undefined,
      headers: [
        {text: "ФИО", value: "user", align: "start", sortable: false, width: "30%"},
        {text: "Дата начала", value: "start_date", align: "center", sortable: false, width: "20%"},
        {text: "Дата окончания", value: "end_date", align: "center", sortable: false, width: "20%"},
        // {text: 'Кол-во АР', value: 'max_auto_one_time', align: 'center', sortable: false, width: '13%'},
        // {text: 'Кол-во АВ', value: 'max_auto_constant', align: 'center', sortable: false, width: '13%'},
        {text: "Активность", value: "is_active", align: "center", sortable: false, width: "10%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"}
      ]
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: "representative/getReplacements",
      count: "representative/getReplacementsCount",
      isLoading: "representative/isLoadingReplacements",
      getCurrentUrl: "representative/getReplacementsCurrentUrl"
    })
  },
  methods: {
    ...mapActions({
      loadReplacementsList: "representative/loadReplacementsList",
      deleteReplacement: "representative/deleteReplacements"
    }),
    loadData(url = undefined) {
      this.loadReplacementsList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newReplacements() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.replacements_data = undefined
    },
    editReplacements(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.replacements_data = item
    },
    deleteReplacements(item) {
      this.dialog_delete = true
      this.replacements_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.replacements_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteReplacement({
          id: this.replacements_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.replacements_data = undefined
    },
    displayDate: displayDate
  },
  created() {
    if (representative.REPRESENTATIVE.ALLOWED_REPLACEMENT()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
